export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comercial_multimedia.vue?vue&type=template&id=15fd82fa&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/comercial_multimedia.vue?vue&type=template&id=15fd82fa&
// module id = null
// module chunks = 